/**
 * Stylized mockup of NIS360 team management (roles & responsibilities) used as
 * a screenshot stand-in on marketing pages. Texts are intentionally hardcoded
 * German, exactly like a real product screenshot would be.
 */

const MEMBERS: { initials: string; name: string; role: string; tasks: string; color: string }[] = [
	{
		initials: "TK",
		name: "Thomas König",
		role: "IT-Leitung",
		tasks: "12 Aufgaben",
		color: "#11110F",
	},
	{
		initials: "SM",
		name: "Sandra Meyer",
		role: "Geschäftsführung",
		tasks: "4 Aufgaben",
		color: "#B8431A",
	},
	{
		initials: "JR",
		name: "Julia Roth",
		role: "Datenschutz",
		tasks: "7 Aufgaben",
		color: "#6B4FA0",
	},
	{
		initials: "AM",
		name: "Andreas Maier",
		role: "IT-Administration",
		tasks: "9 Aufgaben",
		color: "#3DA318",
	},
];

export default function TeamMockup() {
	return (
		<div className="flex flex-col gap-3">
			<div className="flex items-center justify-between">
				<p className="font-urbanist text-[13px] font-bold text-ink">Ihr Compliance-Team</p>
				<span className="font-urbanist text-[10px] font-semibold text-text bg-accent-tint rounded-card px-2.5 py-1">
					+ Mitglied einladen
				</span>
			</div>
			<div className="flex flex-col gap-2">
				{MEMBERS.map((member) => (
					<div
						key={member.name}
						className="flex items-center gap-3 bg-white border border-border rounded-lg px-3 py-2.5"
					>
						<span
							className="w-7 h-7 shrink-0 rounded-full text-white text-[10px] font-semibold flex items-center justify-center font-urbanist"
							style={{ backgroundColor: member.color }}
						>
							{member.initials}
						</span>
						<div className="flex flex-col gap-0.5 min-w-0">
							<p className="font-urbanist text-[11px] font-semibold text-ink truncate">
								{member.name}
							</p>
							<p className="font-urbanist text-[9px] text-subtle">{member.tasks}</p>
						</div>
						<span className="ml-auto shrink-0 font-urbanist text-[9px] font-semibold text-accent-strong bg-accent-tint px-1.5 py-0.5 rounded">
							{member.role}
						</span>
					</div>
				))}
			</div>
		</div>
	);
}
